<template>
  <form class="pa-message-additional-box pa-thumbnail-upload-box">
    <UploadButton
     v-if="viewPosition === 'uploadButton'"
     :isDisabled="isDisabled"
     @onSelected="handleSelectImage"
    />

    <CropperFiled
     v-if="viewPosition === 'cropField'"
     :isLoading="isLoading"
     :isDisabled="isDisabled"
     :uploadFile="uploadFile"
     @onSubmit="handleSubmit"
    />
  </form>
</template>

<script>
import UploadButton from '@/components/Pages/Office/MessageApp/Additionals/ChangeThumbnail/UploadButton.vue'
import CropperFiled from '@/components/Pages/Office/MessageApp/Additionals/ChangeThumbnail/CropperFiled.vue'

export default {
  props : {
    isDisabled  : {
      default: false,
    },

    isLoading   : {
      default: false
    }
  },

  components : {
    UploadButton,
    CropperFiled
  },

  data(){
    return {
      viewPosition  : 'uploadButton',
      uploadFile    : null,
    };
  },

  methods : {
    handleSelectImage(image){
      if(typeof image === 'undefined') return;
      
      this.uploadFile   = image;
      this.viewPosition = 'cropField';

      this.$nextTick(() => {
        this.$parent.$parent.$emit('requestScrollBotom');
      });
    },

    handleSubmit(base64Image){
      this.$emit('onSubmit', base64Image);
    }
  }
}
</script>

<style lang="scss">
form.pa-message-additional-box.pa-thumbnail-upload-box{
  display: block;
  margin:.5rem .1rem .4rem;
  padding:0;
}
</style>